import { Button, Select, Skeleton, useMediaQuery } from "@mui/material";
import { Box, Container } from "@mui/system";
import React, { useEffect, useState } from "react";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import he from 'he';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export default function PageMenu({ items, loading, services, acf }) {

    const mobile=useMediaQuery(theme=>theme.breakpoints.down('md'));
    const navigate=useNavigate();
    const location=useLocation();

    const [mobileSelect, setMobileSelect]=useState();

    useEffect(()=>{
        if(items){
            const urlMatch=items.find(item=>item.url+'/'===location.pathname);
            if(urlMatch){
                setMobileSelect(location.pathname);
            }
            else{
                setMobileSelect(items[0].url+'/');
            }
        }
    },[location, items]);

    //console.log(mobileSelect)

    return(
        <>
            {loading?
                <Skeleton
                    variant='rectangular'
                    height='60px'
                    sx={{
                        m:0,
                    }}
                />
            :
                <Box
                    sx={{
                        backgroundColor:'#F0F0F0'
                    }}
                >
                    <Container maxWidth='xl'
                        sx={{
                            display:'flex',
                            flexDirection:{
                                xs:'column',
                                md:'row'
                            }
                        }}
                    >
                        {mobile?
                            <Box
                                sx={{
                                    m:'1rem 0',
                                    display:'flex'
                                }}
                            >
                                <Select
                                    fullWidth
                                    native
                                    value={mobileSelect}
                                    onChange={(e)=>{
                                        setMobileSelect(e.target.value);
                                        setSelected(e.target.value);
                                    }}
                                    sx={{
                                        background:'white'
                                    }}
                                >
                                    {items?.map((item)=>{
                                        return(
                                            <option value={item.url+'/'}>
                                                {he.decode(item.title)}
                                            </option>
                                        );
                                    })}
                                    {services &&
                                        <option value={'/services/consulting/training/'}>
                                            Training
                                        </option>
                                    }
                                </Select>
                                <Button
                                    onClick={()=>navigate(mobileSelect)}
                                    sx={{
                                        background:'#2a5da5',
                                        '&:hover':{
                                            background:'#2a5da5'
                                        },
                                        color:'#fff',
                                        p:'0.5rem'
                                    }}
                                >
                                    <ArrowForwardIcon/>
                                </Button>
                            </Box>
                        :
                            <>
                                {items && items.map((item)=>{
                                    return(
                                        <Button 
                                            component={RouterLink}
                                            to={`${item.url}/`}
                                            sx={{
                                                textAlign: 'center',
                                                lineHeight: '1.25',
                                                p:{
                                                    xs:'0.5rem 1rem',
                                                    md:'1rem 2rem'
                                                },
                                                color:'#1B314A',
                                                fontSize:'1rem',
                                                borderBottom:{
                                                    xs:'1px solid #c0c0c0',
                                                    md:'none'
                                                },
                                                borderRadius:0,
                                                backgroundColor: item.current_page? 'rgba(0, 0, 0, 0.1)' : 'none',
                                                '&:hover':{
                                                    backgroundColor:'rgba(0, 0, 0, 0.1)'
                                                }
                                            }}
                                        >
                                            {he.decode(item.title)}
                                        </Button>
                                    );
                                })}
                                {services &&
                                    <Button 
                                        component={RouterLink}
                                        to={'/services/consulting/training/'}
                                        sx={{
                                            p:{
                                                xs:'0.5rem 1rem',
                                                md:'1rem 2rem'
                                            },
                                            color:'#1B314A',
                                            fontSize:'1rem',
                                            borderRadius:0,
                                            backgroundColor: '/consulting/training/'===window.location.pathname? 'rgba(0, 0, 0, 0.1)' : 'none',
                                            '&:hover':{
                                                backgroundColor:'rgba(0, 0, 0, 0.1)'
                                            }
                                        }}
                                    >
                                        Training
                                    </Button>
                                }
                            </>
                        }
                    </Container>
                </Box>
            }
        </>
    );
}